import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import * as PIXI from 'pixi.js';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import CreatePageConstants from '../../../../CreatePageConstants';
import VisualizerGlowTypeListItem from './VisualizerGlowTypeListItem';
import VisualizerBlurListItem from './VisualizerBlurListItem';
import VisualizerScaleListItem from './VisualizerScaleListItem';
import VisualizerLogoGlowListItem from './VisualizerLogoGlowListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';

const VisualizerGlowListItem = (props) => {
    const { glowSettingsEnabled, updateVisualizerSettings } = props;

    const onGlowEnabledChange = (value) => updateVisualizerSettings({ 
        glowSettings: { enabled: value }
    });
    
    return (
        <CollapsibleSwitchListItem
            checked={glowSettingsEnabled}
            text='Glow'
            onChange={onGlowEnabledChange}
            warning={PIXI.utils.isWebGLSupported() ? null : CreatePageConstants.LIMITED_VISIBILITY_WARNING_TEXT}
            dense={false}
        >
            <List dense disablePadding>
                <VisualizerGlowTypeListItem />

                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <VisualizerBlurListItem />
                        },
                        {
                            width: 6,
                            component: <VisualizerScaleListItem />
                        }
                    ]}
                />

                <VisualizerLogoGlowListItem />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { enabled: glowSettingsEnabled } = state.createPreview.present.videoSettings.visualizer.glowSettings;
    return { glowSettingsEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerGlowListItem);